/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '#locations-sidebar form' ).on( 'submit', function( e ) {
        e.preventDefault();
        const query = $( this ).find( 'input[name="location-search"]' ).val(); // could be zip, city, or state

        // if there is no query, show all
        if ( !query ) {
          $( '.locations-sidebar__location' ).show();
          return;
        }

        // if the query looks like coordinates, skip geocoding
        const queryRegEx = /^\s*(-?\d+(?:\.\d+)?),(?:\s*(-?\d+(?:\.\d+)?))?\s*$/;
        if ( queryRegEx.test( query ) ) {
          const queriedLat = query.split( ',' )[0];
          const queriedLon = query.split( ',' )[1];

          $( '.locations-sidebar__location' ).each( function( key, location ) {
            const locationLat = parseFloat( $( location ).attr( 'data-lat' ) );
            const locationLon = parseFloat( $( location ).attr( 'data-lon' ) );

            if ( isWithinRadius( queriedLat, queriedLon, locationLat, locationLon ) ) {
              $( location ).show();
            } else {
              $( location ).hide();
            }
          } );

          return;
        }

        // geocode the query
        fetch( `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent( query )}.json?access_token=${llMapbox.token}&limit=1` )
            .then( ( r ) => r.json() )
            .then( ( data ) => {
              const feature = data.features[0];
              const queriedLat = feature.center[1];
              const queriedLon = feature.center[0];

              $( '.locations-sidebar__location' ).each( function( key, location ) {
                const locationLat = parseFloat( $( location ).attr( 'data-lat' ) );
                const locationLon = parseFloat( $( location ).attr( 'data-lon' ) );

                if ( isWithinRadius( queriedLat, queriedLon, locationLat, locationLon ) ) {
                  $( location ).show();
                } else {
                  $( location ).hide();
                }
              } );
            } );
      } );

      function isWithinRadius( lat1, lon1, lat2, lon2, radiusMiles = 50 ) {
        const R = 3958.8; // Radius of the Earth in miles
        const toRad = ( x ) => ( x * Math.PI ) / 180;

        const dLat = toRad( lat2 - lat1 );
        const dLon = toRad( lon2 - lon1 );

        const a =
          Math.sin( dLat / 2 ) ** 2 +
          Math.cos( toRad( lat1 ) ) * Math.cos( toRad( lat2 ) ) *
          Math.sin( dLon / 2 ) ** 2;

        const c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) );

        const distance = R * c;
        return distance <= radiusMiles;
      }

      $( '.locations-sidebar__current-location' ).on( 'click', function() {
        if ( 'geolocation' in navigator ) {
          navigator.geolocation.getCurrentPosition(
              ( position ) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                $( '#locations-sidebar form input[name="location-search"]' ).val( `${latitude}, ${longitude}` ).trigger( 'change' );
                $( '#locations-sidebar form' ).trigger( 'submit' );
              },
              ( error ) => {
                console.error( 'Error getting location:', error );
              },
              {
                enableHighAccuracy: true, // Uses GPS if available
                timeout: 5000, // Wait up to 5 seconds
                maximumAge: 0, // No cached location
              },
          );
        } else {
          console.error( 'Geolocation is not supported by this browser.' );
        }
      } );

      if ( $( '.navbar .alert-banner' ).length && !localStorage.getItem( 'the_center_alert_banner_dismissed' ) ) {
        $( '.alert-banner' ).show();
        addAlertBannerHeights();
      }

      $( '.alert-banner .close-alert' ).on( 'click', function() {
        removeAlertBannerHeights();
      } );

      function addAlertBannerHeights() {
        const root = document.querySelector( ':root' );
        const navbarHeight = parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' ) );
        const alertBannerHeight = parseInt( $( '.navbar .alert-banner' ).outerHeight() );

        const newNavbarHeight = ( navbarHeight + alertBannerHeight ) + 'px';

        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        root.style.setProperty( '--alertBannerHeight', alertBannerHeight + 'px' );
      }

      function removeAlertBannerHeights() {
        const root = document.querySelector( ':root' );
        const navbarHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' );
        const alertBannerHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--alertBannerHeight' );

        const newNavbarHeight = ( parseInt( navbarHeight ) - parseInt( alertBannerHeight ) ) + 'px';

        $( '.alert-banner' ).remove();
        root.style.setProperty( '--alertBannerHeight', '0px' );
        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        localStorage.setItem( 'the_center_alert_banner_dismissed', true );
      }

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      $( document ).on( 'click', '.js-init-video, .wp-block-click-to-play a', function( e ) {
        e.preventDefault();

        let videoUrl = $( this ).attr( 'href' );
        let autoplayMatch = videoUrl?.match( /[?&]autoplay=([01])/ ) || ['autoplay=0'];
        autoplayMatch = autoplayMatch[0].replace( /[?&]/, '' );
        videoUrl = videoUrl.replace( /([?&])autoplay=[01](&|$)/, '$1' ).replace( /\?$/, '' );

        $.magnificPopup.open( {
          items: {
            src: videoUrl,
          },
          type: 'iframe',
          iframe: {
            markup: `
              <div class="mfp-iframe-scaler">
                <div class="mfp-close"></div>
                <iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>
              </div>
            `,
            patterns: {
              youtube: {
                index: 'youtube.com/',
                id: 'v=',
                src: `//www.youtube.com/embed/%id%?${autoplayMatch}`,
              },
              vimeo: {
                index: 'vimeo.com/',
                id: '/',
                src: `//player.vimeo.com/video/%id%?${autoplayMatch}`,
              },
              gmaps: {
                index: '//maps.google.',
                src: '%id%&output=embed',
              },
            },
            srcAction: 'iframe_src',
          },
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      /* Disable duplicate entries on form submit */
      $( function() {
        $( document ).on( 'submit', '.form-skin', function() {
          // Disable submit button
          $( this ).find( 'button[type="submit"]' ).prop( 'disabled', true ).css( 'opacity', 0.2 );
        } );
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      // button hover effect
      let element; let circle; let d; let x; let y;
      $( document ).on( 'mouseover', '.btn', function( e ) {
        element = $( this );

        if ( element.find( '.btn-circle' ).length == 0 ) {
          element.prepend( '<span class=\'btn-circle\'></span>' );
        }

        circle = element.find( '.btn-circle' );
        circle.removeClass( 'animate' );

        if ( !circle.height() && !circle.width() ) {
          d = Math.max( element.outerWidth(), element.outerHeight() );
          circle.css( {height: d, width: d} );
        }

        x = e.pageX - element.offset().left - circle.width()/2;
        y = e.pageY - element.offset().top - circle.height()/2;

        circle.css( {top: y+'px', left: x+'px'} ).addClass( 'animate' );
      } ).on( 'mouseout', '.btn', function( e ) {
        element = $( this );

        circle = element.find( '.btn-circle' );

        if ( !circle.height() && !circle.width() ) {
          d = Math.max( element.outerWidth(), element.outerHeight() );
          circle.css( {height: d, width: d} );
        }

        x = e.pageX - element.offset().left - circle.width()/2;
        y = e.pageY - element.offset().top - circle.height()/2;

        circle.css( {top: y+'px', left: x+'px'} ).removeClass( 'animate' );
      } );
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, delay ) {
        this.callback = callback;
        this.delay = delay;
        this.throttlePause = false;
        this.waitingArgs = null;
        this.timeoutFunc = this.timeoutFunc.bind( this );
      }
      run( ...args ) {
        if ( this.throttlePause ) {
          this.waitingArgs = args;
          return;
        }
        this.callback( ...args );
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( this.timeoutFunc, this.delay );
      }
      timeoutFunc() {
        if ( this.waitingArgs ) {
          this.callback( ...this.waitingArgs );
          this.waitingArgs = null;
          setTimeout( this.timeoutFunc, this.delay );
        } else {
          this.throttlePause = false;
        }
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
